import resources from '../resource.js';

const baseDomain = process.env.VUE_APP_ENDPOINT;
const baseUrl = `${baseDomain}/api/`;
const resource = 'lead';

export default {
    index(page = 1, per_page = 15, order_column = 'id', order_direction = 'desc', search = '', filter = '') {
        return resources.get(`${resource}?page=${page}&per_page=${per_page}&order_column=${order_column}&order_direction=${order_direction}${filter}&search=${search}`);
    },
    show(id) {
        return resources.get(`${resource}/${id}`);
    },
    store() {
        return `${baseUrl}${resource}`
    },
    update(id) {
        return `${baseUrl}${resource}/${id}`
    },
    destroy(id) {
        return resources.delete(`${resource}/${id}`);
    },
    filterData() {
        return resources.get(`${baseUrl}lead-filters`);
    },
    note(id) {
        return `${baseUrl}${resource}/${id}/notes`
    },
    pinNote(note) {
        return `${baseUrl}notes/${note}/pin`
    },
    statuses() {
        return resources.get(`${baseUrl}leadStatus`);
    },
    statusUpdate(id) {
        return `${baseUrl}${resource}/${id}/update-status`;
    },
    statusReasons() {
        return resources.get(`${baseUrl}${resource}/status/reasons`);
    },
    sendApplication(lead) {
        return resources.get(`${baseUrl}send-application/${lead}`);
    },
    membersUpdate(id) {
        return `${baseUrl}${resource}/${id}/assign-lead`;
    },
    assignPartner(id) {
        return `${baseUrl}${resource}/${id}/assign-partner`;
    }
}
